<!-- 编辑和删除支付方式 -->
<template>
  <div>
    <van-nav-bar
      :title="$t('ShopSet.payEdit')"
      left-arrow
      fixed
      z-index="9"
      @click-left="$router.push('/payList')"
    >
      <van-icon
        name="./static/img/Trash.png"
        slot="right"
        style="font-size: 24px;"
        @click="deletePay()"
      />
    </van-nav-bar>
    <div class="contentWrapper">
      <!-- 支付類型 -->
      <van-field
        v-model="payMethods"
        :label="$t('Pay.type')"
        clearable
        readonly
        :placeholder="$t('Pay.selectType')"
        @click="showPaymethods = true"
      />
      <!-- 弹出支付方式 -->
      <van-popup v-model="showPaymethods" position="bottom">
        <van-picker
          show-toolbar
          :columns="methods"
          :confirm-button-text="$t('vantText.confirm')"
          :cancel-button-text="$t('vantText.cancel')"
          @cancel="showPaymethods = false"
          @confirm="onConfirmPayMethods"
        />
      </van-popup>
      <!-- 應用id -->
      <van-field
        v-model="clientId"
        :label="$t('Pay.id')"
        clearable
        :placeholder="$t('Pay.inputId')"
      />
      <!-- 密鑰 -->
      <van-field
        v-model="clientSecret"
        :label="$t('Pay.secret')"
        clearable
        :placeholder="$t('Pay.inputSecret')"
      />
      <!-- 商店代码 -->
      <van-field
        v-if="status"
        v-model="client_code"
        :label="$t('Pay.code')"
        clearable
        :placeholder="$t('Pay.inputCode')"
      />
      <!-- 提交按钮 -->
      <div class="bottom">
        <van-button
          class="issueBtn"
          round
          type="default"
          style="font-weight:bold;font-size:16px;"
          @click="updatePay()"
          >{{ $t("EditStaff.submit") }}</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      payMethods: "",
      clientId: "",
      clientSecret: "",
      client_code: "",
      showPaymethods: false,
      methods: [],
      methodsList: [],
      payment_id: "",
      status: false
    };
  },
  created() {
    console.log(this.$route.params.id);
    this.getDetail();
    this.getpaymentmethod(); //获取支付类型
  },
  methods: {
    // 获取详情
    getDetail() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url:
          this.$build + "/api/storepayment/" + this.$route.params.id + "/show"
      })
        .then(res => {
          if (res.data.status == 200) {
            console.log(res);
            let id = res.data.data.payment_method.id;
            if (this.$i18n.locale == "en") {
              this.payMethods = res.data.data.payment_method.name_en;
            } else {
              this.payMethods = res.data.data.payment_method.name_cn;
            }
            this.status =
              id == 2 || id == 3
                ? true
                : this.radio == "ECpay" || this.radio == "EC Pay"
                ? true
                : false;
            this.clientId = res.data.data.client_id;
            this.clientSecret = res.data.data.client_secret;
            this.client_code = res.data.data.client_code;
            this.payment_id = res.data.data.payment_method.id;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("StaffList.message")
          });
        });
    },
    // 支付类型选择
    getpaymentmethod() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/paymentmethod/outside/index"
      })
        .then(res => {
          if (res.data.status == 200) {
            console.log(res);
            this.methodsList = res.data.data;
            this.methodsList.forEach((item, index) => {
              if (item.name_cn == "现金" || item.name_cn == "凭证支付") {
                this.methodsList.splice(index, 1);
              }
            });
            // 中英文适配
            for (var i = 0; i < this.methodsList.length; i++) {
              if (this.$i18n.locale == "en") {
                this.methods.push(this.methodsList[i].name_en);
              } else {
                this.methods.push(this.methodsList[i].name_cn);
              }
            }
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("StaffList.message")
          });
        });
    },
    // 确认支付方式
    onConfirmPayMethods(value, index) {
      this.showPaymethods = false;
      this.payMethods = value;
      this.payment_id = this.methodsList[index].id;
    },
    // 提交修改
    updatePay() {
      if (this.payMethods && this.clientId && this.clientSecret) {
        let data;
        if (
          this.payment_id == 2 ||
          this.payment_id == 3 ||
          this.radio == "ECpay" ||
          this.radio == "EC Pay"
        ) {
          data = {
            store_id: sessionStorage.actShopId,
            payment_id: this.payment_id,
            client_id: this.clientId,
            client_secret: this.clientSecret,
            client_code: this.client_code
          };
        } else {
          data = {
            store_id: sessionStorage.actShopId,
            payment_id: this.payment_id,
            client_id: this.clientId,
            client_secret: this.clientSecret
          };
        }

        this.$axios({
          method: "PATCh",
          headers: {
            Authorization: "Bearer " + sessionStorage.token
          },
          url:
            this.$build +
            "/api/storepayment/" +
            this.$route.params.id +
            "/update",
          data: data
        })
          .then(res => {
            if (res.data.status == 200) {
              console.log(res);
              this.$toast({
                type: "success",
                message: res.data.message
              });
              var vm = this;
              setTimeout(() => {
                vm.$router.push("/payList");
              }, 1000);
            } else {
              for (var item in res.data.error) {
                this.$toast({
                  type: "fail",
                  message: res.data.error[item]
                });
              }
            }
          })
          .catch(err => {
            this.$toast({
              type: "fail",
              message: this.$t("StaffList.message")
            });
          });
      } else {
        this.$toast({
          type: "fail",
          message: this.$t("NewDish.toast")
        });
      }
    },
    // 删除支付方式
    deletePay() {
      this.$dialog
        .confirm({
          title: this.$t("Pay.delete"),
          message: this.$t("Pay.isDelete"),
          confirmButtonColor: "#2f75f4",
          confirmButtonText: this.$t("vantText.confirm"),
          cancelButtonText: this.$t("vantText.cancel")
        })
        .then(() => {
          this.$axios({
            method: "DELETE",
            headers: {
              Authorization: "Bearer " + sessionStorage.token
            },
            url:
              this.$build +
              "/api/storepayment/" +
              this.$route.params.id +
              "/destroy"
          })
            .then(res => {
              if (res.data.status == 200) {
                console.log(res);
                this.$toast({
                  type: "success",
                  message: res.data.message
                });
                var vm = this;
                setTimeout(() => {
                  vm.$router.push("/payList");
                }, 1000);
              } else {
                for (var item in res.data.error) {
                  this.$toast({
                    type: "fail",
                    message: res.data.error[item]
                  });
                }
              }
            })
            .catch(err => {
              this.$toast({
                type: "fail",
                message: this.$t("StaffList.message")
              });
            });
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
@media screen and (min-width: 800px) {
  .bottom {
    width: 800px;
    margin: 0 auto;
  }
}
@media screen and (max-width: 800px) {
  .bottom {
    width: 100%;
    margin: 0 auto;
  }
}
.bottom {
  position: fixed;
  bottom: 0;
  height: 60px;
  background: #f3f5f7;
}
.issueBtn {
  width: 90%;
  position: absolute;
  left: 50%;
  top: 50%;
  color: #fff;
  transform: translate(-50%, -50%);
  background: #000;
}
/deep/ .van-picker__cancel,
/deep/ .van-picker__confirm {
  color: #2f75f7;
}
/deep/ .van-field__label {
  width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/Pay/EditPay.vue